export default __webpack_public_path__ + "static/media/footer_image_4.a6b6a008.jpg";